// eslint-disable-next-line import/prefer-default-export
export const P24_SOCIAL_URLS = {
  twitter: 'https://twitter.com/puls24news',
  instagram: 'https://www.instagram.com/puls24news/',
  facebook: 'https://www.facebook.com/puls24news',
  tiktok: 'https://www.tiktok.com/@puls24news',
  bluesky: 'https://bsky.app/profile/puls24.at',
};
